import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { SubscriptionsService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionListBloc extends Bloc<SubscriptionsService['subscriptionControllerGet']> {
    public constructor(service: SubscriptionsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.subscriptionControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
